import React from 'react'
import { Shortcut } from 'components'
import getPhrases from 'lang'

const lang = getPhrases()

const quickCommandList = [
	{
		key: 'image',
		value: 'uploadImage',
		group: 'advanced_blocks',
		suggestion: {
			icon: {
				name: 'rte_image',
			},
			meta: <Shortcut commandKey="uploadImage" />,
		},
	},
	{
		key: 'file',
		value: 'uploadFile',
		group: 'advanced_blocks',
		suggestion: {
			icon: {
				name: 'rte_file',
			},
			meta: <Shortcut commandKey="uploadFile" />,
		},
	},
	{
		key: 'separator_line',
		value: 'setHr',
		group: 'advanced_blocks',
		suggestion: {
			icon: {
				name: 'rte_hr',
			},
			// meta: <Shortcut commandKey="setHr" />,
		},
	},
	{
		key: 'code_block',
		value: 'setCodeBlock',
		group: 'advanced_blocks',
		suggestion: {
			icon: {
				name: 'rte_codeblock',
			},
		},
	},
	{
		key: 'hint',
		value: 'setHint',
		group: 'advanced_blocks',
		suggestion: {
			icon: {
				name: 'info',
			},
		},
	},
	{
		key: 'table_of_contents',
		value: 'setTableOfContents',
		group: 'advanced_blocks',
		suggestion: {
			icon: {
				name: 'table-of-content',
			},
		},
	},
	{
		key: 'page_index',
		value: 'setPageIndex',
		group: 'advanced_blocks',
		suggestion: {
			icon: {
				name: 'page-index',
			},
		},
	},
	{
		key: 'youtube',
		value: 'setYoutube',
		group: 'embeds',
		suggestion: {
			image: {
				name: 'setYoutube.svg',
			},
		},
	},
	{
		key: 'vimeo',
		value: 'setVimeo',
		group: 'embeds',
		suggestion: {
			image: {
				name: 'setVimeo.svg',
			},
		},
	},
	{
		key: 'draw_io',
		value: 'setDraw',
		group: 'embeds',
		suggestion: {
			image: {
				name: 'setDraw.svg',
			},
		},
	},
	{
		key: 'figma',
		value: 'setFigma',
		group: 'embeds',
		suggestion: {
			image: {
				name: 'setFigma.svg',
			},
		},
	},
	{
		key: 'github_gist',
		value: 'setGist',
		group: 'embeds',
		suggestion: {
			image: {
				name: 'setGist.svg',
			},
		},
	},
	{
		key: 'codepen',
		value: 'setCodepen',
		group: 'embeds',
		suggestion: {
			image: {
				name: 'setCodepen.svg',
			},
		},
	},
	{
		key: 'headline_large',
		value: 'setH2',
		group: 'basic_blocks',
		suggestion: {
			icon: {
				name: 'rte_h1',
			},
			// meta: <Shortcut commandKey="setH2" />,
		},
	},
	{
		key: 'headline_small',
		value: 'setH3',
		group: 'basic_blocks',
		suggestion: {
			icon: {
				name: 'rte_h2',
			},
			// meta: <Shortcut commandKey="setH3" />,
		},
	},
	{
		key: 'ordered_list',
		value: 'setOrderedList',
		group: 'basic_blocks',
		suggestion: {
			icon: {
				name: 'rte_ordered-list',
			},
			// meta: <Shortcut commandKey="setOrderedList" />,
		},
	},
	{
		key: 'unordered_list',
		value: 'setUnorderedList',
		group: 'basic_blocks',
		suggestion: {
			icon: {
				name: 'rte_unordered-list',
			},
			// meta: <Shortcut commandKey="setUnorderedList" />,
		},
	},
	{
		key: 'quote',
		value: 'setBlockquote',
		group: 'basic_blocks',
		suggestion: {
			icon: {
				name: 'rte_quote',
			},
			// meta: <Shortcut commandKey="setBlockquote" />,
		},
	},
].map(command => {
	const arr = []

	for (const key in lang) {
		arr.push(lang[key].suggestions[command.key])
	}

	return { ...command, keys: arr.join(', ') }
})

const defaultAction = (editor, suggestion, data = null) => {
	editor.command(suggestion.value, data).focus()
}

const quickCommandActions = (editor, suggestion, url = null) => {
	switch (suggestion.value) {
		case 'uploadImage': {
			document.getElementById('image-input').click()

			break
		}
		case 'uploadFile': {
			document.getElementById('file-input').click()

			break
		}
		case 'setYoutube': {
			defaultAction(editor, suggestion, url)

			break
		}
		case 'setVimeo': {
			defaultAction(editor, suggestion, url)

			break
		}
		case 'setDraw': {
			defaultAction(editor, suggestion, url)

			break
		}
		case 'setFigma': {
			defaultAction(editor, suggestion, url)

			break
		}
		case 'setGist': {
			defaultAction(editor, suggestion, url)

			break
		}
		case 'setCodepen': {
			defaultAction(editor, suggestion, url)

			break
		}
		default: {
			defaultAction(editor, suggestion)
		}
	}

	return false
}

export { quickCommandList, quickCommandActions, defaultAction }
